import { Link } from "react-router-dom";
import { cpLines } from "@/mocks/cpLines";

export default function CpTimeline() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-medium tracking-[0.3em] text-primary-600">CP LINES</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              CP 线发展脉络
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              每一段关系都不是一蹴而就。按节点回看，甜与虐的转折点一目了然。
            </p>
          </div>
          <Link
            to="/cp-lines"
            className="whitespace-nowrap rounded-md border border-primary-200 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-50"
          >
            查看全部 CP 线
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {cpLines.map((cp) => (
            <article
              key={cp.id}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img src={cp.cover} alt={`${cp.name} CP线发展脉络封面`} className="h-full w-full object-cover" />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-3 py-1 text-xs text-accent-200 backdrop-blur">
                  {cp.tag}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-xl text-foreground-950">{cp.name}</h3>
                  <span className="text-xs text-foreground-500">{cp.pairing}</span>
                </div>

                <div className="mt-3">
                  <div className="flex items-center justify-between text-xs text-foreground-600">
                    <span>关系热度</span>
                    <span className="text-primary-600">{cp.heat}%</span>
                  </div>
                  <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div className="h-full rounded-full bg-primary-500" style={{ width: `${cp.heat}%` }}></div>
                  </div>
                </div>

                <p className="mt-4 text-sm leading-6 text-foreground-600">{cp.summary}</p>

                <div className="mt-4 space-y-0">
                  {cp.stages.map((s, i) => (
                    <div key={s.stage} className="relative flex gap-3 pb-3 last:pb-0">
                      {i < cp.stages.length - 1 && (
                        <span className="absolute left-[5px] top-5 h-full w-px bg-background-200"></span>
                      )}
                      <span className="mt-1.5 flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full bg-accent-500"></span>
                      <div>
                        <p className="text-sm font-medium text-foreground-950">{s.stage}</p>
                        <p className="mt-0.5 text-xs leading-5 text-foreground-500">{s.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}